import React from "react";
import icons from "../../../../../assets/images/icons";
import styles from "./BlockedUserList.module.scss";
/**
 * 차단 사용자 목록 (01_CHAT 0.0.6 - Figma MCP 40004290:230640 Ban setting)
 * 행: 아바타 32×32, 이름 15px Medium, 차단해제 버튼(Icon/Normal/Lock Open + Label 2/Medium 13px)
 */
function BlockedUserList({ className = "", items = [], onUnblock }) {
  return (
    <div
      className={`${styles.list} ${className}`.trim()}
      data-name="Message List"
      data-node-id="40004311:94097"
    >
      {items.map((item, i) => (
        <div
          key={item.id ?? i}
          className={styles.item}
          data-name="Ban setting"
          data-node-id={i === 0 ? "40004311:94098" : "40004311:94099"}
        >
          <div className={styles.itemInner}>
            <div className={styles.row}>
              <div className={styles.avatar} aria-hidden>
                {item.avatarUrl ? (
                  <img src={item.avatarUrl} alt="" className={styles.avatarImg} />
                ) : (
                  <img
                    src={icons.messager?.person}
                    alt=""
                    className={styles.avatarPlaceholder}
                  />
                )}
              </div>
              <span className={styles.name}>{item.name ?? "대표명"}</span>
              <button
                type="button"
                className={styles.unblockBtn}
                onClick={() => onUnblock?.(item, i)}
                aria-label={`${item.name ?? "대표명"} 차단 해제`}
              >
                {icons.messager?.lockOpen && (
                  <img
                    src={icons.messager.lockOpen}
                    alt=""
                    className={styles.unblockIcon}
                    width={18}
                    height={18}
                  />
                )}
                <span>차단해제</span>
              </button>
            </div>
          </div>
          <div className={styles.itemDivider}>
            <div className={styles.itemDividerLine} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default BlockedUserList;
